exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action-bar__clickable-container__17w7F{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;-ms-flex-positive:1;flex-grow:1;height:100%}.action-bar__menu-button-wrapper__1QIyl{width:100%}.action-bar__menu-button__13mIq{display:block}.action-bar__actions__bkO6Z{background-color:-wix-colors-backgroundColor;color:-wix-colors-buttonsAndLinksColor;transition:height .2s linear}.action-bar__actions__bkO6Z,.action-bar__actions-wrapper__1ujRd{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.action-bar__actions-wrapper__1ujRd{overflow:visible;position:relative;width:100%}.action-bar__buttons__3Tt6_{height:26px}", ""]);

// exports
exports.locals = {
	"clickable-container": "action-bar__clickable-container__17w7F",
	"clickableContainer": "action-bar__clickable-container__17w7F",
	"menu-button-wrapper": "action-bar__menu-button-wrapper__1QIyl",
	"menuButtonWrapper": "action-bar__menu-button-wrapper__1QIyl",
	"menu-button": "action-bar__menu-button__13mIq",
	"menuButton": "action-bar__menu-button__13mIq",
	"actions": "action-bar__actions__bkO6Z",
	"actions-wrapper": "action-bar__actions-wrapper__1ujRd",
	"actionsWrapper": "action-bar__actions-wrapper__1ujRd",
	"buttons": "action-bar__buttons__3Tt6_"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/views/desktop/compact/components/action-bar/action-bar.styl
// module id = 2936
// module chunks = 1